var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRidewithgps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 8,
    y: 8,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,260) scale(0.1,-0.1)",
    fill: "#41474a",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1504 2176 c-34 -8 -79 -23 -100 -34 -44 -23 -113 -91 -79 -77 73 28 151 27 219 -4 25 -11 46 -22 46 -24 0 -2 5 -28 10 -58 13 -65 30 -92 79 -123 128 -81 281 4 269 150 -6 69 -40 114 -115 150 -49 22 -73 27 -163 30 -67 2 -127 -1 -166 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228 1989 c-248 -34 -410 -149 -410 -292 0 -114 41 -168 214 -286 117 -79 233 -194 243 -241 8 -36 -25 -89 -146 -240 -109 -135 -212 -239 -273 -275 -255 -149 -580 -8 -640 279 -42 201 74 404 274 477 51 19 85 24 157 24 51 0 93 3 93 6 0 4 -21 17 -47 29 -55 26 -158 30 -243 10 -148 -34 -288 -149 -350 -289 -106 -234 -42 -490 162 -648 115 -88 231 -123 388 -117 52 2 118 9 145 15 117 27 256 125 385 270 41 46 77 86 80 89 3 3 57 68 120 145 265 323 387 410 567 404 209 -7 370 -117 419 -285 61 -210 -33 -417 -233 -512 -95 -44 -217 -55 -304 -27 -72 24 -135 58 -186 100 -49 41 -64 26 -28 -28 45 -66 160 -134 265 -156 71 -16 212 -12 275 6 178 52 329 206 374 383 73 283 -96 572 -382 655 -31 9 -99 18 -149 20 -140 6 -231 -16 -371 -86 -55 -28 -86 -38 -100 -33 -59 18 -401 256 -425 295 -23 37 49 89 143 103 22 3 52 9 67 12 24 5 37 -3 85 -49 118 -111 227 -158 373 -159 123 -2 294 52 358 112 32 30 27 41 -12 25 -86 -36 -246 -50 -355 -30 -107 19 -211 108 -263 223 -17 37 -32 69 -35 72 -7 8 -172 7 -235 -1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRidewithgps);
export default __webpack_public_path__ + "static/media/ridewithgps.70ae90fcb684029306d041d3079598b6.svg";
export { ForwardRef as ReactComponent };